import React, { Component } from 'react';
import ViewsTable from '../../../../components/tables/ViewsTable';
import FieldModal from '../../../../components/modals/fieldModal';
import InputField from '../../../../components/inputs/inputField';

class AddToGroupModal extends Component {
    constructor(props) {
		super(props);
		const toggledColumns = {};
		const normalizedColumns = Object.keys(props.columns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: props.columns[cfc],
				key: cfc,
				value: cfc,
				type: props.columnTypes[cfc],
				sortAsc: false,
				sortDesc: false
			};
		});

		this.state = {
			checkedEntries: {},
			normalizedColumns: normalizedColumns,
			toggledColumns: toggledColumns,
            searchTerm: '',
            selectedColumnSort: null,
            columns: props.columns,
            sortDesc: false,
        };
	}

	addToGroup = () => {
		const { checkedEntries } = this.state;
		this.props.handleSubmit(Object.keys(checkedEntries), this.props.toggle);
	};

   

    render() {
        const { isOpen, toggle, inGroup, blankTitle } = this.props;
        const { normalizedColumns, toggledColumns, submitting, selectedColumnSort, searchTerm, columns, sortDesc } = this.state;
        let availableEntries = this.props.entries.filter((ent) => !inGroup.includes(ent._id));
        const columnWidth = {
            firstName: 150,
            lastName: 150,
            email: 200
        };

        if (searchTerm.length > 0) {
            const searchTerms = searchTerm.toLowerCase().split(' ');
            searchTerms.forEach((term) => {
                if (term !== '') {
                    availableEntries = availableEntries.filter((entry) => {
                        let found = false;
                        Object.keys(columns).forEach((key) => {
                            if (term !== '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
                                found = true;
                            }
                        });
                        return found;
                    });
                }
            });
        }

        if (selectedColumnSort) {
            availableEntries = availableEntries.sort((a, b) => {
                const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
                if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
                    switch (columnType) {
                        case 'string':
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                        case 'number':
                            return a[selectedColumnSort.key] - b[selectedColumnSort.key];
                        case 'currency':
                            return a[selectedColumnSort.key] - b[selectedColumnSort.key];
                        case 'date':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'time':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'boolean':
                            const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
                            const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
                            return a1.localeCompare(b1);
                        case 'bool':
                            const c1 = a[selectedColumnSort.key] ? 'yes' : 'no';
                            const d1 = b[selectedColumnSort.key] ? 'yes' : 'no';
                            return c1.localeCompare(d1);
                        default:
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                    }
                } else if (a[selectedColumnSort.key]) {
                    return 1;
                }
                return -1;
            });
            availableEntries = sortDesc ? availableEntries.reverse() : availableEntries;
        }

        return (
            <div>
                <FieldModal
                    size="large"
                    isOpen={isOpen}
                    modalTitle={this.props.title}
                    bodyHeaderText={''}
                    bodyDescription={''}
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    classes="viewSearch"
                                    placeholder="Search "
                                    clickIcon={true}
                                    required={true}
                                    value={this.state.searchTerm}
                                    onChange={(e) => {
                                        clearTimeout(this.searchTimeout);
                                        this.setState({ searchTerm: e.target.value || '' });
                                    }}
                                    prefix={<i className="las la-search" style={{ marginRight: 5, transform: 'rotate(270deg)' }} />}
                                    inputIcon={this.state.searchTerm !== '' &&
                                        <i
                                            onMouseDown={() => this.setState({ searchTerm: '', searching: false })}
                                            className="las la-times-circle"
                                            style={{ visibility: this.state.searchTerm === '' ? 'hidden' : 'visible' }}
                                        />}
                                />
                                <ViewsTable
                                    title={blankTitle}
                                    style={{ margin: 0, height: 'calc(100vh - 300px)' }}
                                    columnWidth={columnWidth}
                                    classes={'fit'}
                                    columns={normalizedColumns}
                                    toggledColumns={toggledColumns}
                                    data={availableEntries}
                                    mainColumnActive={false}
                                    checked={this.state.checkedEntries}
                                    checkRow={(entryId) => {
                                        const checked = this.state.checkedEntries;
                                        checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
                                        this.setState({
                                            checkedEntries: checked
                                        });
                                    }}
                                    checkAllRows={(entryIds) => {
                                        let checked = this.state.checkedEntries;
                                        entryIds.length > 0
                                            ? entryIds.forEach((entryId) => {
                                                checked[entryId] = true;
                                            })
                                            : (checked = {});
                                        this.setState({
                                            checkedEntries: checked
                                        });
                                    }}
                                />
                            </div>
                        );
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Submit' : 'Adding...'}
                    actionButton={() => this.addToGroup()}
                    actionButtonDisabled={submitting}
                    isFullWidthBody={true}
                ></FieldModal>
            </div>
        );
    }
}

export default AddToGroupModal;